import { useMemo } from 'react';
import { getDisciplinesForSearchParamsMapping } from "../components/CEF/Utilities/MapTools";

// the fields is an array of categories and subcategories mixed together
// for all subcategories in fields, map to category:subcategory and remove the categories
// for categories that don't have subcategories leave them in
export function useFieldsOfStudyParamMapping(fields, fieldsOfEducation) {
  var fieldsOfStudyParamMapping = useMemo(function () {
    return getDisciplinesForSearchParamsMapping(fields, fieldsOfEducation);
  }, [fields, fieldsOfEducation]);
  return fieldsOfStudyParamMapping;
}